import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "LittleBottle",
  "use": "LittleBottle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"LittleBottle\">\n  <path d=\"m11.087 5.693-.634-.213A.66.66 0 0 1 10 4.853V2c0-.367-.3-.667-.667-.667h-2c-.366 0-.666.3-.666.667v2.853c0 .287-.187.54-.454.634L5.58 5.7c-.547.18-.913.687-.913 1.26v6.373c0 .734.6 1.334 1.333 1.334h4.667c.733 0 1.333-.6 1.333-1.334V6.96a1.34 1.34 0 0 0-.913-1.267ZM8 2.667h.667v.666H8v-.666ZM6 6.96l.633-.213A1.985 1.985 0 0 0 8 4.853v-.186h.667v.186a2 2 0 0 0 1.366 1.9l.634.207V8H6V6.96Zm4.667 6.373H6V12h4.667v1.333Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol